import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import { PORTION_API } from "../../Api";

const BASE_URL = process.env.REACT_APP_SERVER_URL;

const PortionMasterApi = createApi({
  reducerPath: "PortionMaster",
  baseQuery,
  tagTypes: ["PortionMaster"],
  endpoints: (builder) => ({
    getPortionMaster: builder.query({
      query: ({ params, searchParams }) => {
        if (searchParams) {
          return {
            url: PORTION_API + "/search/" + searchParams,
            method: "GET",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
            params
          };
        }
        return {
          url: PORTION_API,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          params
        };
      },
      providesTags: ["PortionMaster"],
    }),
    getPortionMasterById: builder.query({
      query: (id) => {
        return {
          url: `${PORTION_API}/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      providesTags: ["PortionMaster"],
    }),
    addPortionMaster: builder.mutation({
      query: (payload) => ({
        url: PORTION_API,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["PortionMaster"],
    }),
    updatePortionMaster: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;
        return {
          url: `${PORTION_API}/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["PortionMaster"],
    }),
    deletePortionMaster: builder.mutation({
      query: (id) => ({
        url: `${PORTION_API}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["PortionMaster"],
    }),
  }),
});

export const {
  useGetPortionMasterQuery,
  useGetPortionMasterByIdQuery,
  useAddPortionMasterMutation,
  useUpdatePortionMasterMutation,
  useDeletePortionMasterMutation,
} = PortionMasterApi;

export default PortionMasterApi;
